import { createFileRoute } from '@tanstack/react-router';
import { Button } from '@/shared/components/base-button';
import { CommonRoute } from '@/constants/routes';
import { useAuth } from '@/context/AuthContext';
import { loginRequestScope } from '@/constants/msal';
import { clearSesionStorage } from '@/utils/storage';

export const Route = createFileRoute('/retry/')({
  component: RetryComponent,
});

function RetryComponent() {

  const { login } = useAuth();

  const handleRetry = async () => {
    try {
      clearSesionStorage();
      localStorage.clear();
      login(loginRequestScope || []);
    } catch (error) {
      window.location.href = CommonRoute.LOGIN;
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-[#E8F9FF] to-[#EDEBFB]">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg
              className="w-8 h-8 text-red-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            Sesión Expirada
          </h1>
          <p className="text-gray-600">
            Tu sesión ha expirado por inactividad. Por favor, inicia sesión
            nuevamente para continuar.
          </p>
        </div>

        <div className="space-y-3">
          <Button
            appearance="primary"
            widthVariant="full"
            onClick={handleRetry}
            className="w-full h-11 rounded-lg"
          >
            Iniciar Sesión Nuevamente
          </Button>

          <p className="text-sm text-gray-500 mt-4">
            Si el problema persiste, contacta al administrador del sistema.
          </p>
        </div>
      </div>
    </div>
  );
}
